import { render, staticRenderFns } from "./GoogleSERPPreview.vue?vue&type=template&id=51623ed8&scoped=true&"
import script from "./GoogleSERPPreview.vue?vue&type=script&lang=ts&"
export * from "./GoogleSERPPreview.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleSERPPreview.vue?vue&type=style&index=0&id=51623ed8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51623ed8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAppBar,VCard,VCardText,VDivider,VIcon,VSpacer,VToolbarTitle,VTooltip})
